import React, { Component } from 'react';
import {
  Container,
  // Modal, ModalHeader, ModalBody,
  // ModalFooter,
  Button,
  Row, Col, Label, Input
} from 'reactstrap';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import "react-table/react-table.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faStar } from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarOutline } from '@fortawesome/free-regular-svg-icons'
import AddContact from '../../components/Contacts/AddContactModal';
import EditContact from '../../components/Contacts/EditContact';
import CollapseCard from '../../components/CollapseCard/CollapseCard';
import PermissionWrapper from '../../auth/PermissionWrapper';
import Autocomplete from '../../components/Autocomplete/Autocomplete';
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../../components/Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';

class Contacts extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);

    this.path = String(this.props.location.pathname).split('/')[2];

    this.state = {
      isLoading: true,
      contacts: [],
      selectedRow: null,
      modalOpen: false,
      editCategoryCommentsArray: [],
      addCategoryCommentsArray: [],
      addCategorySubCommentsArray: [],
      notesCategories: [],
      editID: 0,
      companies: [],
      showInactive: false,
      showMissingCompanies: false,
      scrollYBeforeModal: 0,
      reactTablePage: 0,
      reactTablePageSize: 50,
      reactTableSorted: [],
      reactTableFiltered: [],
      unsavedChanges: false,
    };

    this.contactColumns = [
      {
        Header: <FontAwesomeIcon icon={faStar} />,
        accessor: 'favorites',
        filterable: false,
        width: 60,
        Cell: row => (parseInt(row.original['favorites']) > 0) ?
          <FontAwesomeIcon
            icon={faStar}
            className="favoriteIcon"
            onClick={(e) => {
              e.stopPropagation();
              this.props.removeFavorite('contact', row.original['linkedID'], this.favoriteCallback);
            }}
          />
          :
          <FontAwesomeIcon
            icon={faStarOutline}
            className="favoriteIconDisabled"
            onClick={(e) => {
              e.stopPropagation();
              this.props.addFavorite('contact', row.original['linkedID'], this.favoriteCallback);
            }}
          />
      },
      {
        Header: 'Contact Name',
        accessor: d => d.children ? d.children["Contact Name"] : "",
        id: 'Contact Name',
        filterable: true,
        filterMethod: this.noBlanksFilterMethod,
        sortMethod: this.sortMethod,
        Cell: (props) => {
          return (
            <span className="text-primary">
              {props.value}
            </span>
          );
        },
      },
      {
        Header: 'Title',
        accessor: d => d.children ? d.children["Title"] : "",
        id: 'Title',
        filterable: true,
        filterMethod: this.noBlanksFilterMethod,
        sortMethod: this.sortMethod
      },
      {
        Header: 'Phone',
        accessor: d => d.children ? d.children["Phone Number"] : "",
        id: 'Phone',
        filterable: true,
        width: 150,
        filterMethod: this.noBlanksFilterMethod,
        sortMethod: this.sortMethod
      },
      {
        Header: 'Email',
        accessor: d => d.children ? d.children["Email Address"] : "",
        id: 'Email',
        filterable: true,
        filterMethod: this.noBlanksFilterMethod,
        sortMethod: this.sortMethod
      },
      {
        Header: 'Companies',
        id: 'companies',
        accessor: 'companies', // No need to join into a string, just keep the array
        width: 400,
        Cell: (props) => {
          if (!props.value || !Array.isArray(props.value)) return null;

          return (
            <>
              {props.value.map((company, index) => {
                const primaryBusinessName = company.primaryBusinessName || 'Unknown';
                const secID = company.secID || '';

                return (
                  <span key={secID + '_' + index}>
                    <Link
                      to={{ pathname: `/demographics/${secID}`, state: {} }}
                      style={{ marginRight: '8px' }}
                    >{primaryBusinessName} ({secID})</Link>
                    {index < props.value.length - 1 ? < br /> : <></>}
                  </span>
                );
              })}
            </>
          );
        },
        filterable: true,
        filterMethod: (filter, row) => {
          if (!filter.value) return true;

          // Extract the companies array from row data
          const companies = row[filter.id] || [];

          return companies.some(company => {
            const primaryBusinessName = company.primaryBusinessName?.toLowerCase() || '';
            const secID = company.secID?.toLowerCase() || '';
            return primaryBusinessName.includes(filter.value.toLowerCase()) || secID.includes(filter.value.toLowerCase());
          });
        }
      },
      {
        Header: 'Created',
        accessor: 'created',
        width: 100,
        Cell: (props) => {
          const custom_date = props.value
          let custom_date_format = custom_date.substr(5, 2) + '/' + custom_date.substr(8, 2) + '/' + custom_date.substr(0, 4)
          return <>{custom_date_format}</>
        }
      },
      {
        Header: 'Updated',
        accessor: 'timestamp',
        width: 100,
        Cell: (props) => {
          const custom_date = props.value
          let custom_date_format = custom_date.substr(5, 2) + '/' + custom_date.substr(8, 2) + '/' + custom_date.substr(0, 4)
          return <>{custom_date_format}</>
        }
      },
      // {
      //   Header: 'Active',
      //   accessor: 'active',
      //   width: 60,
      //   Cell: (props) => {
      //     return props.value ? <></> : <>No</>;
      //   }
      // },
    ]
  }

  componentDidMount = () => {
    this.getContacts(() => {
      if (this.path) {
        this.handleRowClick(this.state.contacts[0], null)
      }
    });
    this.getNotesCategories();
    // this.props.setContactsHandleAdd(this.handleAddSubmit);
  }

  toggleModal = () => {
    const closing = this.state.modalOpen;
    this.setState((prev) => {
      return {
        modalOpen: !closing,
        companies: closing ? [] : prev.companies
      }
    }, () => {
      if (closing) {
        setTimeout(() => {
          window.scrollTo({ top: this.state.scrollYBeforeModal });
        }, 0);
      }
    });
  };

  favoriteCallback = (data) => {
    const contacts = this.state.contacts.map(result => ({
      ...result,
      favorites: ("contact" in data && data.contact.findIndex(item => item.Favorite === result['linkedID']) > -1) ? 1 : ''
    }));
    this.setState({ contacts });
  }

  handleRowClick = (row, event) => {
    // Prevent modal from opening if clicking on a Link
    if (event?.target?.tagName === "A") return;
    const currentScrollY = window.scrollY;
    // console.log('row', row)
    this.setState({
      scrollYBeforeModal: currentScrollY,
      selectedRow: row,
      companies: row.companies,
      // modalOpen: true
    }, () => {
      window.scrollTo({ top: 0 });
      this.handleEditSwap(row.linkedID);
    });
  };

  noBlanksFilterMethod = (filter, row) => {
    const filterValue = filter.value.toLowerCase().trim();
    const cellValue = row[filter.id];

    // If filterValue is empty (no search input), show all records
    if (!filterValue) return true;

    // If cellValue is empty or blank, do not show it when filtering
    if (!cellValue || cellValue.toString().trim() === '') return false;

    // If cellValue is an array, check each name inside
    if (Array.isArray(cellValue)) {
      return cellValue.some(contact => {
        const name = contact?.toLowerCase().trim() || '';
        return name.includes(filterValue);
      });
    }

    // For normal text values, apply filter
    return cellValue.toString().toLowerCase().includes(filterValue);
  }

  sortMethod = (a, b) => {
    const valA = a ? a.toString().toLowerCase().trim() : "";
    const valB = b ? b.toString().toLowerCase().trim() : "";

    if (valA === "" && valB !== "") return 1;
    if (valB === "" && valA !== "") return -1;

    return valA.localeCompare(valB);
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  parseNdjsonStream = async ({ response, onRow, signal }) => {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let leftover = "";

    while (true) {
      if (signal?.aborted) break;
      const { value, done } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      const text = leftover + chunk;
      const lines = text.split("\n");
      leftover = lines.pop() || ""; // save last partial line

      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed) continue;
        try {
          const obj = JSON.parse(trimmed);
          if (onRow) onRow(obj);
        } catch {
          // ignore malformed lines (or log)
        }
      }
    }

    // flush any final full line
    const tail = leftover.trim();
    if (tail) {
      try {
        const obj = JSON.parse(tail);
        if (onRow) onRow(obj);
      } catch { }
    }
  };

  getContacts = async (cb) => {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    this.setState({ isLoading: true, companies: [], contacts: [] }, async () => {
      const headers = {
        'Accept': 'application/x-ndjson',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      };

      const resp = await fetch(`/api/contacts/${this.props.user}${this.path ? '/0/' + this.path : ''}`, {
        method: 'GET',
        headers,
        signal: this.abortController.signal
      });

      if (!resp.ok || !resp.body) {
        this.setState({ isLoading: false });
        return;
      }

      const next = [];           // local accumulator
      let raf = null;

      const flush = () => {
        // replace with current snapshot instead of concat
        this.setState({ contacts: next.slice() });
        raf = null;
      };

      await this.parseNdjsonStream({
        response: resp,
        signal: this.abortController.signal,
        onRow: (row) => {
          next.push(row);
          if (!raf) raf = requestAnimationFrame(flush);
        }
      });

      // final replace
      this.setState({ contacts: next, isLoading: false }, () => cb && cb());
    });
  }

  getNotesCategories = () => {
    // console.log('Contacts.js/getNotesCategories')
    fetch('/api/notesCategories/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        this.setState({
          loading: false,
          notesCategories: results.data.filter(item => item.type === 'Contact')[0]?.children || [],
          addCategoryCommentsArray: results.data.filter(item => item.type === 'Contact')[0]?.children || [],
          addCategorySubCommentsArray: results.data.filter(item => item.type === 'Sales Activity')[0]?.children || [],
          debug_message: results.debug_message,
        });
      });
    return;
  }

  changeComment = (e, validation = null) => {
    const dataArray = [...this.state.editCategoryCommentsArray];
    const field = dataArray.find(item => parseInt(item.ID) === parseInt(e.target.name));

    if (!field) return;

    // Handle input types
    if (e.target.type === 'select-multiple') {
      field.value = Array.from(e.target.selectedOptions, option => option.value);
    } else if (e.target.type === 'checkbox') {
      field.value = e.target.checked;
    } else {
      field.value = e.target.value;
    }

    // Validation logic
    if (validation != null) {
      const matches = String(field.value).match(new RegExp(validation));
      field.error = matches == null;
    }

    // Clear error if empty
    if (field.value === '' || field.value == null) {
      field.error = false;
    }

    this.setState({
      unsavedChanges: true,
      editCategoryCommentsArray: dataArray
    });

    // Optional callback
    // this.props.setUnsavedChanges(true);
  };

  setComment = (e, validation = null) => {
    const dataArray = [...this.state.addCategoryCommentsArray];
    const field = dataArray.find(item => parseInt(item.ID) === parseInt(e.target.name));

    if (!field) return;

    if (e.target.type === 'select-multiple') {
      field.value = Array.from(e.target.selectedOptions, option => option.value);
    } else if (e.target.type === 'checkbox') {
      field.value = e.target.checked;
    } else {
      field.value = e.target.value;
    }

    if (validation != null) {
      const matches = String(field.value).match(new RegExp(validation));
      field.error = (matches == null);
    }

    if (field.value === '' || field.value == null) {
      field.error = false;
    }

    this.setState({
      addCategoryCommentsArray: dataArray,
      unsavedChanges: true
    });
  };

  handleAddSubmit = () => {
    // console.log('Contacts.js/handleAddSubmit');
    let dataObj = {};
    let active = true;
    this.state.addCategoryCommentsArray.filter(item => item.value !== '' && item.value != null).forEach(item => {
      if (item.type === 'Inactive' && (item.value === 1 || Boolean(item.value))) {
        active = false;
      } else {
        dataObj[item.type] = item.value;
      }
    });
    this.setState({
      loading: true,
    },
      () => {
        fetch('/api/contacts/companies/', {
          method: 'POST',
          body: JSON.stringify({
            data: JSON.stringify(dataObj),
            companies: this.state.companies,
            auth0: this.props.user,
            active: active
          }),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.props.clientToken,
            'X-Database': this.context.company
          }
        })
          .then(results => results.json())
          .then(results => {
            if (results.debug_message == null) {
              this.setState({
                addCategoryCommentsArray: [],
                loading: false,
                unsavedChanges: false
              }, () => {
                this.getContacts();
                this.toggleModal();
              })
            }
          });
      });
  }

  handleEditSubmit = (e) => {
    // console.log('Contacts.js/handleEditSubmit (e)', e.target.name, e.target.value);
    let dataObj = {};
    let active = true;
    const contactGUID = e.target.value;
    this.state.editCategoryCommentsArray.filter(item => item.value !== '' && item.value != null).forEach(item => {
      if (item.type === 'Inactive' && (item.value === 1 || Boolean(item.value))) {
        active = false;
      } else {
        dataObj[item.type] = item.value;
      }
    })
    this.setState(
      { loading: true },
    );
    fetch('/api/contacts/' + contactGUID, {
      method: 'PUT',
      body: JSON.stringify({
        data: JSON.stringify(dataObj),
        auth0: this.props.user,
        active: active
      }),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        if (results.debug_message == null) {
          fetch('/api/contacts/companies/' + contactGUID, {
            method: 'PUT',
            body: JSON.stringify({
              companies: this.state.companies != null ? this.state.companies.map(company => company.secID) : []
            }),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.props.clientToken,
              'X-Database': this.context.company
            }
          })
            .then(results2 => results2.json())
            .then(results2 => {
              if (results2.debug_message == null) {
                // this.handleDelete({ target: { value: results.linkedID } });
                this.setState({
                  editID: 0,
                  editCategoryCommentsArray: [],
                  unsavedChanges: false
                }, () => {
                  this.getContacts();
                  this.toggleModal();
                  // this.props.setUnsavedChanges(false);
                })
              }
            }
            )
        }
      });
  }

  displayEditCategories = (val) => {
    // console.log('Contacts.js/displayEditCategories (val)', val)
    const dataList = typeof (this.state.contacts.filter(
      item => item.linkedID === val
    )[0]) !== 'undefined' ? this.state.contacts.filter(
      item => item.linkedID === val
    )[0] : [];
    const categoryList = this.state.notesCategories/*.filter(
        item => Object.keys(dataList.children).findIndex(key => key === item.type) > -1
    );*/
    categoryList.forEach(item => {
      const matchData = Object.keys(dataList.children).filter(key => key === item.type);
      if (matchData.length > 0) {
        item.value = dataList.children[matchData[0]];
        // item.commentID = matchData[0].ID;
        // item.parentID = matchData[0].parentID;
        // item.error = false;
      } else {
        item.value = "";
        // item.commentID = null;
        // item.parentID = null;
        // item.error = false;
      }
    })
    if (categoryList.findIndex(item => item.type === "Inactive") > -1) {
      categoryList[categoryList.findIndex(item => item.type === "Inactive")].value = !dataList.active;
    }
    // console.log(dataList, categoryList)
    this.setState({
      editCategoryCommentsArray: categoryList
    });
  };

  isFormBlank(array) {
    // console.log('Contacts.js/isFormBlank (array)', array)
    let retBool = true;
    array.forEach(row => {
      if (row.value !== null && row.value !== '') { retBool = false; }
    })
    return retBool;
  }

  handleEditSwap = (val) => {
    // console.log('Contacts.js/handleEditSwap (val)', val, this.state.editID)
    this.displayEditCategories(val);
    // this.props.setUnsavedChanges(false);
    this.toggleModal();
    this.setState({
      // otherCategories: {},
      editID: val !== this.state.editID ? val : 0,
      unsavedChanges: false
    });
  }

  handleDelete = (e) => {
    // console.log('Contacts.js/handleDelete (e)', e.target.name, e.target.value)
    fetch('/api/contacts/' + e.target.value, {
      method: 'DELETE',
      //body: json_request,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        if (results.debug_message == null) {
          this.setState(
            { editID: 0, loading: false, unsavedChanges: false },
            () => {
              this.getContacts();
              this.toggleModal();
              // this.props.setUnsavedChanges(false);
            }
          );
        }
      });
  }

  displayCategories = (e) => {
    // console.log('Contacts.js/displayCategories (e)', e.target.name, e.target.value)
    const categoryList = typeof (this.state.notesCategories.filter(
      item => parseInt(item.ID) === parseInt(e.target.value)
    )[0]) !== 'undefined' ? this.state.notesCategories.filter(
      item => parseInt(item.ID) === parseInt(e.target.value)
    )[0].children : [];
    categoryList.forEach((item) => { item.value = null; })
    const categoryValue = parseInt(e.target.value);
    // console.log('display', categoryValue, categoryList)
    this.setState({
      selectValue: categoryValue,
      // addCategoryCommentsArray: categoryList
    });
  };

  onSelectAutocomplete = (val) => {
    console.log('onSelectAutocomplete')
    this.setState((prevState) => {
      // Check if secID already exists in the array
      const exists = prevState.companies?.some(company => company.secID === val.sec);

      // If it exists, return the previous state without changes
      if (exists) return prevState;

      // Otherwise, add the new company

      if (!prevState.companies) prevState.companies = [];

      const arr = [...prevState.companies, { primaryBusinessName: val.name, secID: val.sec }];
      return { companies: arr };
    });
  }

  removeCompany = (secID) => {
    this.setState((prevState) => ({
      companies: prevState.companies.filter((company) => company.secID !== secID),
    }));
  };

  closeModal = () => {
    this.setState({
      editCategoryCommentsArray: [],
      editID: 0,
      unsavedChanges: false
    })
  }

  handleCancel = () => {
    this.setState({
      addCategoryCommentsArray: [],
      modalOpen: false,
      unsavedChanges: false
    })
  }

  render() {
    // if (!this.state.isLoading) {
    const dataContacts = [...this.state.contacts]
      .filter(contact => (this.state.showInactive && !contact.active) || (!this.state.showInactive && contact.active) || this.path)
      .filter(contact => (this.state.showMissingCompanies && (contact.companies == null || contact.companies?.length === 0)) || (!this.state.showMissingCompanies && contact.companies?.length > 0) || this.path);
    let contactTitle = 'Active & Matched Contacts';
    if (this.path) {
      contactTitle = 'Contact Detail';
    } else if (this.state.showInactive && this.state.showMissingCompanies) {
      contactTitle = 'Inactive & Missing Companies';
    } else if (this.state.showInactive) {
      contactTitle = 'Inactive Contacts';
    } else if (this.state.showMissingCompanies) {
      contactTitle = 'Contacts With Missing Companies';
    }
    return (
      <PermissionWrapper {...this.props} allowedPermission="Contacts">
        <Prompt
          when={this.state.unsavedChanges}
          message="You have unsaved changes, are you sure you want to leave?"
        />
        {/* <Modal size="xl" isOpen={this.state.modalOpen} toggle={this.toggleModal} onClosed={this.closeModal}>
            <ModalHeader toggle={this.toggleModal}>Contact Details</ModalHeader>
            <ModalBody>
              
            </ModalBody>
          </Modal> */}
        <Container fluid className='pz-0'>
          {this.state.modalOpen && <Row>
            <Col md={4}>
              <Autocomplete
                clientToken={this.props.clientToken}
                available_dates={this.props.available_dates}
                newPage={false}
                onSelect={(val) => this.onSelectAutocomplete(val)}
                enableHistory={true}
                clearOnSelect={true}
                placeholder="Search to Add Company"
                showContacts={false}
              />
              {this.state?.companies?.map((company, companyIndex) => (
                <Row key={company.secID + '_' + companyIndex} className='border-top border-light py-2 my-2'>
                  <Col md={9}>
                    <Link
                      to={{ pathname: `/demographics/${company.secID}`, state: {} }}
                      style={{ marginRight: '8px' }}
                    ><div>{company.primaryBusinessName}</div><Label>{company.secID}</Label></Link>
                    {/* <div>({company.secID})</div> */}
                  </Col>
                  <Col className='text-right'>
                    <ConfirmButton
                      color="danger"
                      onClick={() => this.removeCompany(company.secID)}
                      title="Delete"
                    ><FontAwesomeIcon icon={faTrashAlt} /></ConfirmButton>
                  </Col>
                </Row>
              ))}
            </Col>
            <Col className="pl-5">
              {this.state.editCategoryCommentsArray.length > 0 ?
                <EditContact
                  {...this.props}
                  addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                  addCategorySubCommentsArray={this.state.addCategorySubCommentsArray}
                  editCategoryCommentsArray={this.state.editCategoryCommentsArray}
                  changeComment={this.changeComment}
                  notesCategories={this.state.notesCategories}
                  handleEditSubmit={this.handleEditSubmit}
                  displayEditCategories={this.displayEditCategories}
                  row={this.state.selectedRow}
                  handleEditSwap={this.handleEditSwap}
                  handleDelete={this.handleDelete}
                  isFormBlank={this.isFormBlank}
                  displayCategories={this.displayCategories}
                  editID={this.state.editID}
                  unsavedChanges={this.state.unsavedChanges}
                />
                :
                <AddContact
                  {...this.props}
                  addCategoryCommentsArray={this.state.addCategoryCommentsArray}
                  // changeComment={this.changeComment}
                  notesCategories={this.state.notesCategories}
                  handleAddSubmit={this.handleAddSubmit}
                  handleCancel={this.handleCancel}
                  setComment={this.setComment}
                  // displayEditCategories={this.displayEditCategories}
                  // row={this.state.selectedRow}
                  // handleEditSwap={this.handleEditSwap}
                  // handleDelete={this.handleDelete}
                  isFormBlank={this.isFormBlank}
                  unsavedChanges={this.state.unsavedChanges}
                />
              }
            </Col>
          </Row>}
          {!this.path && !this.state.modalOpen && <Row>
            <Col md={3} className='text-left pt-3 pl-5'>
              <Label>
                <Input
                  type="checkbox"
                  checked={this.state.showInactive}
                  name="showInactive"
                  onChange={() => this.setState({ showInactive: !this.state.showInactive })}
                />
                Show Inactive
              </Label>
              <Label>
                <Input
                  type="checkbox"
                  checked={this.state.showMissingCompanies}
                  name="showMissingCompanies"
                  onChange={() => this.setState({ showMissingCompanies: !this.state.showMissingCompanies })}
                />
                Show Missing Companies
              </Label>
            </Col>
            <Col md={6} className='text-center'>
              <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                <h1>Contacts</h1>
              </PermissionWrapper>
            </Col>
            <Col md={3} className="text-right pt-4 pr-4">
              <Button
                color="primary"
                onClick={() => this.setState({ modalOpen: true })}
              >
                Add Contact
              </Button>
            </Col>
          </Row>}
          {!this.state.modalOpen &&
            <CollapseCard title={`${contactTitle} (${dataContacts.length})`} open={true}>
              <ReactTable
                data={dataContacts}
                columns={this.contactColumns}
                pageSize={50}
                page={this.state.reactTablePage}
                sorted={this.state.reactTableSorted}
                filtered={this.state.reactTableFiltered}
                onPageChange={(pageIndex) => this.setState({ reactTablePage: pageIndex })}
                onPageSizeChange={(pageSize, pageIndex) => this.setState({ reactTablePageSize: pageSize, reactTablePage: pageIndex })}
                onSortedChange={(newSorted) => this.setState({ reactTableSorted: newSorted })}
                onFilteredChange={(filtered) => this.setState({ reactTableFiltered: filtered })}
                showPagination={true}
                defaultSorted={[{ id: "Contact Name", desc: false }]}
                getTrProps={(state, rowInfo) => {
                  if (!rowInfo) return {};

                  return {
                    onClick: (event) => this.handleRowClick(rowInfo.original, event),
                    style: {
                      cursor: "pointer"
                    }
                  };
                }}
              />
            </CollapseCard>}
        </Container>
      </PermissionWrapper>
    );
    // } else {
    //   return (<></>
    //     // <h1>Reports</h1>
    //   )
    // }
  }
}

export default Contacts;
